import React, { Component } from 'react';
import Header from '../components/header/Header';
import { Colors, StyledComponents, Metrics } from '../themes';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import SnackbarNotification from '../components/common/SnackbarNotification';
import DistributorInfos from '../components/homeWidgets/DistributorInfos';
import DoorManualControl from '../components/homeWidgets/DoorManualControl';
import PersonCounter from '../components/homeWidgets/PersonCounter';
import ActivateTag from '../components/homeWidgets/ActivateTag';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.home,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
    minHeight: 392,
    [theme.breakpoints.up('xl')]: {
      maxWidth: 800,
    },
  },
  paperLowerRow: {
    minHeight: Metrics.widgetMinHeight,
  },
  distributorInfos: {
    background: Colors.navBackgroundGrey,
  },
  DoorManualControl: {
    display: 'flex',
    flexDirection: 'column',
  },
});

class Home extends Component {
  state = {
    isSnackbarNotificationOpen: false,
    snackbarVariant: 'warning',
    snackbarMessage: '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sitesIsLoading && !this.props.sitesIsLoading) {
      if (this.props.sitesErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.sitesErrorMessage,
        });
      }
    }
    if (prevProps.personCountIsLoading && !this.props.personCountIsLoading) {
      if (this.props.personCountErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.personCountErrorMessage,
        });
      }
    }
  }

  render() {
    const { classes, width, ajax } = this.props;
    const isLarge = width === 'lg' || width === 'xl';

    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <SnackbarNotification
          open={this.state.isSnackbarNotificationOpen}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6}>
            <Paper className={clsx(classes.paper, classes.distributorInfos)}>
              <DistributorInfos />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={clsx(classes.paper, classes.DoorManualControl)}>
              <DoorManualControl sendGetSitesRequest={this.sendGetSitesRequest} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={clsx([classes.paper, classes.paperLowerRow])}>
              <PersonCounter sendGetSitesRequest={this.sendGetSitesRequest} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={clsx([classes.paper, classes.paperLowerRow])}>
              <ActivateTag />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ajax: state.ajax,
    sitesIsLoading: state.sites.isLoading,
    sitesErrorMessage: state.sites.errorMessage,

    personCountIsLoading: state.personCount.isLoading,
    personCountErrorMessage: state.personCount.errorMessage,
  };
};

export default compose(withStyles(styles), withWidth(), connect(mapStateToProps, null))(Home);
